module.exports = __webpack_public_path__ + "img/info-grey.d8c6dd0b.svg";